import { render, staticRenderFns } from "./ecImageItem.vue?vue&type=template&id=6624b410&lang=pug"
import script from "./ecImageItem.vue?vue&type=script&lang=ts"
export * from "./ecImageItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VImg/VImg.js').default})
